import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {TranslatePipe} from "@ngx-translate/core";
import {Component, inject, Input, OnInit} from "@angular/core";
import {InputComponent} from "../../../shared/form/input/input.component";
import {AddressDataInfoDto} from "../../../models/student-ticket/list-view/AddressDataInfoDto";
import {SelectComponent} from "../../../shared/form/select/select.component";
import {EnumHelperService} from "../../../@core/utils/forms/enum-helper.service";
import {PlzValidationHelperService} from "../../../@core/utils/forms/plz-validation-helper.service";
import {AbstractFormModalComponent} from "../../../shared/modal/abstract-form-modal.component";
import {ModalShellComponent} from "../../../shared/modal/modal-shell/modal-shell.component";

@Component({
  selector: 'app-address-details-adjust-modal',
  templateUrl: './address-details-adjust-modal.component.html',
  styleUrls: ['./address-details-adjust-modal.component.scss'],
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    InputComponent,
    SelectComponent,
    ModalShellComponent
  ],
  standalone: true
})
export class AddressDetailsAdjustModalComponent extends AbstractFormModalComponent implements OnInit {

  @Input() addressDetails: AddressDataInfoDto;

  protected form: UntypedFormGroup;
  protected validationErrorKey = 'ADDRESS_DATA.VALIDATION_ERROR';

  landList = [];

  private readonly fb = inject(UntypedFormBuilder);
  private readonly enumHelperService = inject(EnumHelperService);
  readonly plzHelper = inject(PlzValidationHelperService);

  ngOnInit(): void {
    this.form = this.fb.group({
      street: [this.addressDetails.street, [Validators.required]],
      city: [this.addressDetails.city, [Validators.required]],
      postalCode: [this.addressDetails.postalCode, [Validators.required]],
      country: [this.addressDetails.country, [Validators.required]],
      addressAddition: [this.addressDetails.addressAddition, []],
    });
    this.setPlzPatternValidator();
    this.landList = this.enumHelperService.getLandOptionListKV();
  }

  // todo: this patern differs from setPlzPatternValidator(plzControlName: string, landControlName: string): void
  setPlzPatternValidator(): void {
    const land = this.form?.get('country')?.value;
    const postalCodeControl = this.form?.get('postalCode');
    if (postalCodeControl) {
      if (land) {
        postalCodeControl.setValidators([
          Validators.required,
          Validators.maxLength(this.plzHelper.getMaxPlzLength(land)),
          Validators.pattern(this.plzHelper.getPlzPattern(land))
        ]);
      } else {
        postalCodeControl.setValidators([Validators.required]);
      }
      postalCodeControl.updateValueAndValidity();
    }
  }

  get postalCodeErrorLabel(): string {
    if (this.form?.get('postalCode')?.hasError('required')) {
      return 'ADDRESS_DATA.FIELD_ERROR.REQUIRED';
    }
    if (this.form?.get('postalCode')?.hasError('pattern')) {
      return 'ADDRESS_DATA.FIELD_ERROR.POSTALCODE';
    }
    return 'ADDRESS_DATA.FIELD_ERROR.POSTALCODE';
  }

  protected getCloseValue(): unknown {
    return this.form.value;
  }
}
